import classcat from "classcat";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";
import { PreferenceOption } from "@is/types";

import css from "./AttributeTab.module.css";

type Props = {
  attribute: PreferenceOption;
  isSelected: boolean;
  onTabSelect?: (tab: string) => void;
};

const TRANSLATED_ATTRIBUTE_LABELS = [
  "Category",
  "Subcategory",
  "Gender",
  "Length",
  "Sizes",
  "Brand",
  "Price",
];

const AttributeTab = ({ attribute, isSelected, onTabSelect }: Props) => {
  const { t } = useTranslation(TranslationContext.ProductListing);

  const handleSelect = useCallback(() => {
    onTabSelect && onTabSelect(attribute.key);
  }, [attribute, onTabSelect]);

  const label = useMemo(() => {
    if (attribute.label in TRANSLATED_ATTRIBUTE_LABELS) {
      return t(attribute.label);
    }
    return attribute.label;
  }, [attribute, t]);

  return (
    <div className={css.container}>
      <button
        className={classcat([
          css.button,
          "text-label-lg",
          { [css.selected]: isSelected },
        ])}
        onClick={handleSelect}
      >
        {label}
      </button>
      <div
        className={classcat([css.borderBottom, { [css.selected]: isSelected }])}
      />
    </div>
  );
};

export default AttributeTab;
